import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import axios from "axios";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";

const cookie = new Cookies();

const InformacionGrupoAyB = ({ institucion }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [modalIsOpen, setIsOpen] = useState(false);

  // 🔹 Opciones filtros
  const grupos = [
    "A1",
    "A2",
    "A3",
    "A4",
    "A5",
    "A6",
    "A7",
    "A8",
    "A9",
    "A10",
    "B1",
    "B2",
    "B3",
  ];

  const estado = ["DISPONIBLE", "NO DISPONIBLE"];

  // 🔹 Endpoint
  const urlendpoint = useMemo(() => {
    const tipo = Number(cookie.get("tipo_Usuario")); // 🔥 FIX

    if (!institucion && tipo !== 2) return null;

    switch (tipo) {
      case 1:
      case 3:
      case 4:
      case 6:
        return `https://suadesarrollo.azurewebsites.net/api/QIndicadorAyBInstitucionId?InstitucionId=${institucion}`;
      case 2:
        return `https://suadesarrollo.azurewebsites.net/api/QIndicadorAyBInstitucionId?InstitucionId=${cookie.get("institucionid")}`;
      default:
        return null;
    }
  }, [institucion]);

  // 🔹 Carga de datos SOLO cuando abre modal
  useEffect(() => {
    if (!modalIsOpen || !urlendpoint) return;

    setLoading(true);
    setError(null);

    axios
      .get(urlendpoint, {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((res) => {
        const response = Array.isArray(res.data) ? res.data : [];
        setData(response);
      })
      .catch((err) => {
        console.error(err);
        setError("Error al cargar la información");
        setData([]);
      })
      .finally(() => setLoading(false));
  }, [modalIsOpen, urlendpoint]);

  // 🔹 Columnas COMPLETAS
  const columns = useMemo(
    () => [
      { accessorKey: "id", header: "Id", filterVariant: "text" },
      {
        accessorKey: "grupo",
        header: "Grupo",
        filterVariant: "multi-select",
        filterSelectOptions: grupos,
      },
      {
        accessorKey: "nombreIndicador",
        header: "Nombre del Indicador",
        filterVariant: "text",
      },
      {
        accessorKey: "codigo",
        header: "Código Único",
        filterVariant: "text",
      },
      {
        accessorKey: "nivelDesagregacion",
        header: "Nivel Desagregación",
        filterVariant: "text",
      },
      {
        accessorKey: "aplicabilidad",
        header: "Aplicabilidad",
        filterVariant: "text",
      },
      {
        accessorKey: "estadoInformacion",
        header: "Estado Información",
        filterVariant: "multi-select",
        filterSelectOptions: estado,
      },
      {
        accessorKey: "unidadMedicion",
        header: "Unidad de medición",
        filterVariant: "text",
      },
      {
        accessorKey: "numerador",
        header: "Numerador",
        filterVariant: "text",
      },
      {
        accessorKey: "denominador",
        header: "Denominador",
        filterVariant: "text",
      },
      {
        accessorKey: "resultado",
        header: "Resultado",
        filterVariant: "text",
      },
      {
        accessorKey: "mesCorte",
        header: "Mes Corte",
        filterVariant: "text",
      },
      {
        accessorKey: "nombreInstitucion", // 🔥 mejor que institucionId
        header: "Institución",
        filterVariant: "text",
      },
      {
        accessorKey: "sede",
        header: "Sede",
        filterVariant: "text",
      },
      {
        accessorKey: "trimestre",
        header: "Año",
        filterVariant: "range",
        filterFn: "betweenInclusive",
      },
      {
        accessorKey: "observaciones",
        header: "Observaciones",
        filterVariant: "text",
      },
    ],
    [],
  );

  return (
    <div>
      <Button variant="contained" onClick={() => setIsOpen(true)}>
        Ver Información de los Indicadores
      </Button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        {/* 🔹 DEBUG */}
        <Typography variant="caption" sx={{ display: "block", mb: 2 }}>
          Endpoint: {urlendpoint || "No definido"}
        </Typography>

        {/* 🔹 SIN INSTITUCIÓN */}
        {!institucion && (
          <Typography textAlign="center" mt={5}>
            ⚠️ Seleccione una institución
          </Typography>
        )}

        {/* 🔹 LOADING */}
        {loading && (
          <Box textAlign="center">
            <CircularProgress />
          </Box>
        )}

        {/* 🔹 ERROR */}
        {!loading && error && <Typography color="error">{error}</Typography>}

        {/* 🔹 TABLA */}
        {!loading && !error && Array.isArray(data) && data.length > 0 && (
          <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnFilters
            enableColumnOrdering
            enableSorting
            enablePagination
            enableRowSelection
            initialState={{ showColumnFilters: true }}
          />
        )}

        {/* 🔹 SIN DATOS */}
        {!loading && !error && Array.isArray(data) && data.length === 0 && (
          <Typography textAlign="center">
            No hay datos para esta institución
          </Typography>
        )}
      </ReactModal>
    </div>
  );
};

export default InformacionGrupoAyB;
